import {createAction} from 'redux-actions';
import {Booking, Reservation} from '../api/types';

export interface BookingDetailsFetchedPayload {
    booking: Booking[] | Booking;
}

export interface VisitorBookingsFetchedPayload {
    visitorBookings: Booking[];
}

export interface GuestBookingFetchedPayload {
    booking: Booking;
}

export interface ReservationCreatedPayload {
    reservation: Reservation;
}

/* eslint-disable max-len */
export const bookingDetailsFetched = createAction<BookingDetailsFetchedPayload>('BOOKING_DETAILS_FETCHED');
export const visitorBookingsFetched = createAction<VisitorBookingsFetchedPayload>('VISITOR_BOOKINGS_FETCHED');
export const guestBookingFetched = createAction<GuestBookingFetchedPayload>('GUEST_BOOKING_FETCHED');
export const reservationCreated = createAction<ReservationCreatedPayload>('RESERVATION_CREATED');
